import "./categoriesModal.css";
import leftIcon from "../icons/play-left.png";
import rightIcon from "../icons/play-right.png";
import addIcon from "../icons/plus.png";
import penIcon from "../icons/pen.png";
import usersIcon from "../icons/users.png";
import { useEffect, useRef, useState } from "react";
import { setFontSize } from "../utils/fonts";
import { useGlobalContext } from "../../../../Context/Context";

const CategoriesModal = ({ notebookRef, newCategories, setNewCategories }) => {
  const { categories, setCategories } = useGlobalContext();

  const [addingActive, setAddingActive] = useState(false);
  const [items, setItems] = useState(categories);

  const modalRef = useRef();
  const inputRef = useRef();

  const setFonts = () => {
    const title = notebookRef.current.querySelector(".categories-modal-title");
    setFontSize(title, 2);
    const names = notebookRef.current.querySelectorAll(
      ".categories-modal-item-text"
    );
    names.forEach((name) => setFontSize(name, 2));
    if (addingActive) setFontSize(inputRef.current, 2);
  };

  const setItemDim = () => {
    const headerDim = notebookRef.current
      .querySelector(".categories-modal-header")
      .getBoundingClientRect();
    const items = notebookRef.current.querySelectorAll(
      ".categories-modal-item"
    );
    items.forEach(
      (item) => (item.style.height = `${headerDim.height / 1.2}px`)
    );
    const itemsContainer = notebookRef.current.querySelector(
      ".categories-modal-items"
    );
    itemsContainer.style.gap = `${headerDim.height / 20}px`;
    setFonts();
  };

  const checkIfExists = (name) => {
    return newCategories.find((item) => item.name === name);
  };

  const addCategory = (cat, exists) => {
    let anotherCategories = [];
    if (exists)
      anotherCategories = newCategories.filter((c) => cat.name !== c.name);
    else anotherCategories = [...newCategories, cat];
    setNewCategories(anotherCategories);
  };

  const addIntoAllCategories = () => {
    const name = inputRef.current.value;
    if (name === "") return;
    const exists = categories.find(
      (c) => c.name.toUpperCase() === name.toUpperCase()
    );
    if (exists) return;
    const newCat = {
      name,
      icon: usersIcon,
    };
    setCategories([newCat, ...categories]);
    setItems([newCat, ...categories]);
    setAddingActive(false);
  };

  window.addEventListener("resize", setItemDim);

  useEffect(() => {
    setItemDim();
    return () => window.removeEventListener("resize", setItemDim);
    // eslint-disable-next-line
  }, [addingActive]);

  return (
    <div className="categories-modal" ref={modalRef}>
      <div className="categories-modal-header">
        <img src={leftIcon} alt="" />
        <span className="categories-modal-title">KATEGORIJE</span>
        <img src={rightIcon} alt="" />
      </div>
      <div className="categories-modal-main">
        <div className="categories-modal-items-wrapper">
          <div className="categories-modal-items">
            {addingActive && (
              <div className="categories-modal-item">
                <div
                  className="categories-modal-item-icon"
                  onClick={addIntoAllCategories}
                >
                  <img src={addIcon} alt="" />
                </div>
                <input ref={inputRef} />
              </div>
            )}
            {items.map((cat, index) => {
              const { icon, name } = cat;
              const exists = checkIfExists(name);
              return (
                <article
                  className={
                    exists
                      ? "categories-modal-item added"
                      : "categories-modal-item"
                  }
                  key={index}
                >
                  <div className="categories-modal-item-icon">
                    <img src={icon} alt="" />
                  </div>
                  <span
                    className="categories-modal-item-text"
                    onClick={() => addCategory(cat, exists)}
                  >
                    {name}
                  </span>
                  {index === categories.length - 1 && (
                    <div
                      className="categories-modal-item-icon gray"
                      onClick={() => setAddingActive(!addingActive)}
                    >
                      <img src={addIcon} alt="" />
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        </div>
        <div className="categories-modal-button">
          <img src={penIcon} alt="" />
        </div>
      </div>
    </div>
  );
};

export default CategoriesModal;
